"use strict";
var $ = require("../internals/export");
var uncurryThis = require("../internals/function-uncurry-this");
var fails = require("../internals/fails");
var thisNumberValue = require("../internals/this-number-value");
var nativeToPrecision = uncurryThis(1.1.toPrecision);
var FORCED = fails(function() {
  return nativeToPrecision(1, void 0) !== "1";
}) || !fails(function() {
  nativeToPrecision({});
});
$({ target: "Number", proto: true, forced: FORCED }, {
  toPrecision: function toPrecision(precision) {
    return precision === void 0 ? nativeToPrecision(thisNumberValue(this)) : nativeToPrecision(thisNumberValue(this), precision);
  }
});
